<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="novels"></a>
<a id="page_i"></a>
<a id="page_ii"></a>
<p class="center" id="nove_p1">
<b>Parker Novels By Richard Stark</b>
</p>
<p class="extra-indent2" id="nove_p2"> </p>
<p class="center" id="nove_p3">
<i>The Hunter (Payback)<br/><br/>
The Man with the Getaway Face<br/><br/>
The Outfit<br/><br/>
The Mourner<br/><br/>
The Score<br/><br/>
The Jugger<br/><br/>
The Seventh<br/><br/>
The Handle<br/><br/>
The Rare Coin Score<br/><br/>
The Green Eagle Score<br/><br/>
The Black Ice Score<br/><br/>
Deadly Edge<br/><br/>
Slayground<br/><br/>
Lemons Never Lie<br/><br/>
Plunder Squad<br/><br/>
Butcher's Moon<br/><br/>
Comeback<br/><br/>
Backflash<br/><br/>
Flashfire<br/><br/>
Firebreak<br/><br/>
Ask the Parrot<br/><br/>
Dirty Money</i>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// novels.vue?292a1e17